import { Component } from "react";
import styles from './footer-v2.component.module.scss';

export default class FooterV2Component extends Component<any, any> {
    constructor(props: {}) {
        super(props);
    }
    render() {
        return <footer className={styles.footer}>
            <div className={styles.container}>
                <nav className={styles.toolLinks}>
                    <div className={styles.toolColumn}>
                        <h4 className={styles.columnTitle}>Image Tools</h4>
                        <a href="/image-compressor">Image Compressor</a>
                        <a href="/compress-jpeg">Compress JPEG</a>
                        <a href="/compress-png">Compress PNG</a>
                        <a href="/compress-gif">Compress GIF</a>
                        <a href="/compress-webp">Compress WebP</a>
                        <a href="/image-converter">Image Converter</a>
                        <a href="/jpg-converter">JPG Converter</a>
                        <a href="/image-resizer">Image Resizer</a>
                    </div>
                    <div className={styles.toolColumn}>
                        <h4 className={styles.columnTitle}>Video Tools</h4>
                        <a href="/video-compressor">Video Compressor</a>
                        <a href="/compress-mp4">Compress MP4</a>
                        <a href="/convert-mp4-to-gif">MP4 to GIF</a>
                        <a href="/convert-video-to-gif">Video to GIF</a>
                        <a href="/video-converter">Video Converter</a>
                        <a href="/mp4-converter">MP4 Converter</a>
                        <a href="/video-cutter">Video Cutter</a>
                    </div>
                    <div className={styles.toolColumn}>
                        <h4 className={styles.columnTitle}>Audio Tools</h4>
                        <a href="/audio-compressor">Audio Compressor</a>
                        <a href="/compress-mp3">Compress MP3</a>
                        <a href="/compress-wav">Compress WAV</a>
                        <a href="/audio-converter">Audio Converter</a>
                        <a href="/mp3-converter">MP3 Converter</a>
                        <a href="/convert-flac-to-mp3">FLAC to MP3</a>
                        <a href="/audio-cutter">Audio Cutter</a>
                    </div>
                    <div className={styles.toolColumn}>
                        <h4 className={styles.columnTitle}>Document Tools</h4>
                        <a href="/compress-pdf">Compress PDF</a>
                        <a href="/merge-image-to-pdf">Merge Images to PDF</a>
                        <a href="/split-pdf">Split PDF</a>
                        <a href="/convert-pdf-to-jpg">PDF to JPG</a>
                        <a href="/extract-zip">Unzip Files</a>
                        <a href="/extract-rar">RAR Extractor</a>
                    </div>
                    <div className={styles.toolColumn}>
                        <h4 className={styles.columnTitle}>Converters</h4>
                        <a href="/time-converter">Time Zone Converter</a>
                        <a href="/time-converter/meeting-planner">Meeting Planner</a>
                        <a href="/time-converter/ist-to-est-converter">IST to EST</a>
                        <a href="/time-converter/timezone-abbreviations">Time Zone Abbreviations</a>
                        <a href="/unit-converter">Unit Converter</a>
                        <a href="/unit-converter/length">Length Converter</a>
                        <a href="/unit-converter/volumeFlowRate">Flow Rate Converter</a>
                    </div>
                </nav>
                <div className={styles.bottom}>
                    <div className={styles.copyright}>
                        &copy; {new Date().getFullYear()} XConvert.com. All Rights Reserved.
                    </div>
                    <nav className={styles.links}>
                        <a href="/about-us" className={styles.link}>About Us</a>
                        <a href="/privacy-policy" className={styles.link}>Privacy Policy</a>
                        <a href="/terms-of-service" className={styles.link}>Terms of Service</a>
                        <a href="/contact-us" className={styles.link}>Contact</a>
                        <a href="/how-to-help-xconvert-to-grow" className={styles.link}>Help Us Grow</a>
                    </nav>
                </div>
            </div>
        </footer>
    }
}